import { render, staticRenderFns } from "./ItemizeRestaurant.vue?vue&type=template&id=bcaa52ae"
import script from "./ItemizeRestaurant.vue?vue&type=script&lang=js"
export * from "./ItemizeRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports